import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRibbonOutlined = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 11 14",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.75 0.75C9.10362 0.75 9.44276 0.890476 9.69281 1.14052C9.94286 1.39057 10.0833 1.72971 10.0833 2.08333V12.0833C10.0833 12.2001 10.0526 12.3148 9.99432 12.4159C9.93604 12.5171 9.85222 12.6012 9.75124 12.6598C9.65026 12.7183 9.53566 12.7494 9.41892 12.7498C9.30217 12.7502 9.18737 12.7199 9.086 12.662L6.078 10.9433C5.87658 10.8283 5.64863 10.7678 5.41667 10.7678C5.1847 10.7678 4.95675 10.8283 4.75533 10.9433L1.74733 12.662C1.64596 12.7199 1.53116 12.7502 1.41441 12.7498C1.29767 12.7494 1.18307 12.7183 1.0821 12.6598C0.981116 12.6012 0.897293 12.5171 0.839013 12.4159C0.780732 12.3148 0.750038 12.2001 0.75 12.0833V2.08333C0.75 1.72971 0.890476 1.39057 1.14052 1.14052C1.39057 0.890476 1.72971 0.75 2.08333 0.75H8.75Z",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgRibbonOutlined;
